// Sign-in MFA: the email from step 1 (email + password) is needed again for
// step 2 (email + OTP). It travels in router state, with a sessionStorage copy
// (this tab only) so a refresh of the OTP page keeps working. It is never put
// in the URL, where it would end up in history, logs and Referer headers.
const MFA_EMAIL_KEY = "mfaEmail";

export const MFA_VERIFY_ROUTE = "/signin/verify";

export interface MfaLocationState {
  email?: string;
}

export const saveMfaEmail = (email: string) => {
  try {
    sessionStorage.setItem(MFA_EMAIL_KEY, email);
  } catch {
    // Storage blocked: router state still carries the email.
  }
};

export const getMfaEmail = (state?: MfaLocationState | null): string | null => {
  if (state?.email) return state.email;
  try {
    return sessionStorage.getItem(MFA_EMAIL_KEY);
  } catch {
    return null;
  }
};

export const clearMfaEmail = () => {
  try {
    sessionStorage.removeItem(MFA_EMAIL_KEY);
  } catch {
    // Nothing to clear.
  }
};
